import { render } from "./EmpleadoIdentificacionTipoList.vue?vue&type=template&id=3729c8c7&scoped=true"
import script from "./EmpleadoIdentificacionTipoList.vue?vue&type=script&lang=js"
export * from "./EmpleadoIdentificacionTipoList.vue?vue&type=script&lang=js"

import "./EmpleadoIdentificacionTipoList.vue?vue&type=style&index=0&id=3729c8c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3729c8c7"]])

export default __exports__